export const DEFAULT_ENABLED = true;

export const DEFAULT_PAGE_TRANSITION_ENABLED = true;
export const DEFAULT_PAGE_TRANSITION = 'fade';
export const DEFAULT_PAGE_TRANSITION_ANIMATION_IN_DURATION_MS = 200;
export const DEFAULT_PAGE_TRANSITION_ANIMATION_OUT_DURATION_MS = 200;

export const DEFAULT_PAGE_TRANSITION_SETTINGS = {
  enabled: DEFAULT_PAGE_TRANSITION_ENABLED,
  transition: DEFAULT_PAGE_TRANSITION,
  durationIn: DEFAULT_PAGE_TRANSITION_ANIMATION_IN_DURATION_MS,
  durationOut: DEFAULT_PAGE_TRANSITION_ANIMATION_OUT_DURATION_MS,
};
